import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/**
 *  Узел дерева отчетов
 * */
let PitReportsTreeNode = class PitReportsTreeNode {
    /**
     *  Узел дерева отчетов
     * */
    constructor() {
        this._parentId = null;
    }
    getItemId() {
        return this._id;
    }
    getParentItemId() {
        return this._parentId;
    }
    setParentItemId(value) {
        this._parentId = value;
    }
    getItemType() {
        return this._type;
    }
    setItemType(value) {
        this._type = value;
    }
    getItemOrd() {
        return this._ord;
    }
    getItemTitle() {
        return this._title;
    }
    getItemIdent() {
        return this._ident;
    }
    getItemIcon() {
        return "";
    }
    getItemDescription() {
        return this._description;
    }
    getItemSearchString() {
        return "";
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get parentId() {
        return this._parentId;
    }
    set parentId(value) {
        this._parentId = value;
    }
    get ord() {
        return this._ord;
    }
    set ord(value) {
        this._ord = value;
    }
    get ident() {
        return this._ident;
    }
    set ident(value) {
        this._ident = value;
    }
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    get description() {
        return this._description;
    }
    set description(value) {
        this._description = value;
    }
    get link() {
        return this._link;
    }
    set link(value) {
        this._link = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitReportsTreeNode.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "parentId", constructor: Number, emitDefaultValue: false, preserveNull: true, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], PitReportsTreeNode.prototype, "_parentId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitReportsTreeNode.prototype, "_ord", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ident", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitReportsTreeNode.prototype, "_ident", void 0);
tslib_1.__decorate([
    jsonMember({ name: "title", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitReportsTreeNode.prototype, "_title", void 0);
tslib_1.__decorate([
    jsonMember({ name: "type", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitReportsTreeNode.prototype, "_type", void 0);
tslib_1.__decorate([
    jsonMember({ name: "description", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitReportsTreeNode.prototype, "_description", void 0);
tslib_1.__decorate([
    jsonMember({ name: "link", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitReportsTreeNode.prototype, "_link", void 0);
PitReportsTreeNode = tslib_1.__decorate([
    jsonObject
], PitReportsTreeNode);
export { PitReportsTreeNode };
